<template>
  <div class="vx-col md:w-3/5 w-full mb-base m-auto">
    <vx-card title="Change Password">
      <div class="vx-row mb-2">
        <div class="vx-col w-full">
          <vs-input
            class="w-full"
            type="password"
            label="Old Password"
            v-validate="'required'"
            name="old_password"
            v-model="old_password"
            autocomplete="off"
          />
          <span class="text-danger text-sm">{{ errors.first('old_password') }}</span>
        </div>
      </div>
      <div class="vx-row mb-2">
        <div class="vx-col w-full">
          <vs-input
            class="w-full"
            ref="password"
            type="password"
            label="New Password"
            v-validate="'required|verify_password|min:8|max:20'"
            name="password"
            v-model="new_password"
            autocomplete="off"
          />
          <span class="text-danger text-sm">{{ errors.first('password') }}</span>
        </div>
      </div>

      <div class="vx-row mb-2">
        <div class="vx-col w-full">
          <vs-input
            class="w-full"
            type="password"
            label="Confirm New Password"
            @keyup.enter.native="update()"
            v-validate="'required|confirmed:password'"
            name="password_confirmation"
            v-model="confirm_password"
            autocomplete="off"
          />
          <span class="text-danger text-sm">{{ errors.first('password_confirmation') }}</span>
        </div>
      </div>

      <div class="vx-row mt-6">
        <div class="vx-col w-full">
          <vs-button
            class="mt-4 shadow-lg m-auto"
            type="gradient"
            color="#39b54a"
            gradient-color-secondary="#4cd964"
            @click="update()"
            :disabled="button_loading"
            id="reset-password"
          >Save</vs-button>
          <vs-button class="mt-4 ml-4 m-auto" color="warning" @click="cancel()">Cancel</vs-button>
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
import { Validator } from "vee-validate";

  Validator.extend('verify_password', {
        //getMessage: field => `The password must contain at least: 1 uppercase letter, 1 lowercase letter, 1 number, and 1 special character (E.g. , . _ & ? etc)`,
        validate: value => {
            var strongRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})");
            return strongRegex.test(value);
        }
    });

const dict = {
  custom: {
    old_password: {
      required: "Old password is required"
    },
    password: {
      required: "New password is required",
      min: "Password should be minimum 8 characters",
      verify_password: "Password should be minimum 8 characters : 1 uppercase letter, 1 lowercase letter, 1 number, and 1 special character (E.g. , . _ & ? etc)"
    },
    password_confirmation: {
      required: "Confirm password is required",
      confirmed: "Confirm password and New password should be same"
    }
  }
};
// register custom messages
Validator.localize("en", dict);
export default {
  data() {
    return {
      old_password: null,
      new_password: null,
      confirm_password: null,
      roles: null,
    };
  },
  mounted() {
    if (this.$store.state.uInfo) {
      let user = this.$store.state.uInfo;
      this.roles= user.role;
    }
  },
  methods: {
    update() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.button_loader(true, "#reset-password");
          let input = {
            oldPassword: this.old_password,
            newPassword: this.new_password
          };
          this.axios
            .post("auth/resetPassword", input)
            .then(response => {
              this.button_loader(false, "#reset-password");
              let text = "Password updated successfully!!!";
              this.$vs.notify({
                text: text,
                color: "success",
                position: "top-right"
              });
              if (this.roles === 'SA') {
                this.$router.push({ name: "adminDashboard" });
                          
              }
              if(this.roles === 'CA' || this.roles === 'HR'){
                this.$router.push({ name: "organizationDashboard" });
              }
            })
            .catch(e => {
              this.showError(e,"#reset-password");
            });
        }
      });
    },
    cancel() {
      history.back();
    }
  }
};
</script>

<style>
</style>
